<template>
  <div class="facet-checkbox-wrapper">
    <AtomicUiCheckboxBasic
      :model-value="criteriaCheckbox"
      spacing="margin-bottom-xs"
      name="criteria-checkbox"
      :options="criteriaOptions"
      @update:model-value="updateCheckboxCriteria"
    />
  </div>
</template>

<script setup>
import { useFilteringFacetsStore } from '~/stores/filteringFacets';
import { GET_ALL_SELECTED_CRITERIA, REPLACE_SELECTED_VALUES, REMOVE_CHECKBOX_VALUES_BY_VALUE } from '~/types/actions';
import useDisplay from '~/composables/filteringFacets/useDisplay';
import useFacetOptions from '~/composables/filteringFacets/useFacetOptions';
import useSortFilter from '~/composables/filteringFacets/useSortFilter';

const filteringFacetsStore = useFilteringFacetsStore();

const { screen } = useDisplay();
const { facetByName, updateFacet, removeCheckBoxValuesByValue } = useSortFilter();
const { activeDropdown } = useFacetOptions();

const props = defineProps({
  name: {
    type: String,
    default: 'Category',
  },
});

const criteriaCheckbox = computed(() => {
  if (screen.value.isMobile) {
    return facetByName(props.name)?.selectedValues;
  }
  return filteringFacetsStore.facetByName(props.name)?.selectedValues;
});

const criteriaOptions = computed(() => {
  if (screen.value.isMobile) {
    return facetByName(props.name)?.values;
  }
  return filteringFacetsStore.facetByName(props.name)?.values;
});

const updateCheckboxCriteria = (selected) => {
  if (screen.value.isMobile) {
    if (props.name === 'Price') {
      const customPrice = criteriaOptions.value.filter((value) => value.label.indexOf('Custom:') > -1);
      if (customPrice.length > 0) {
        const customPriceValue = customPrice[0].value;

        removeCheckBoxValuesByValue({
          name: props.name,
          value: customPriceValue,
        });

        updateFacet({
          name: props.name,
          selectedValues: selected.filter((value) => value !== customPriceValue),
        });
      }
    } else {
      updateFacet({
        name: props.name,
        selectedValues: selected,
      });
    }
  } else if (props.name === 'Price') {
    const customPrice = criteriaOptions.value.filter((value) => value.label.indexOf('Custom:') > -1);
    if (customPrice.length > 0) {
      const customPriceValue = customPrice[0].value;

      filteringFacetsStore[REMOVE_CHECKBOX_VALUES_BY_VALUE]({
        name: props.name,
        value: customPriceValue,
      });

      filteringFacetsStore[REPLACE_SELECTED_VALUES]({
        name: props.name,
        selectedValues: selected.filter((value) => value !== customPriceValue),
      });
      activeDropdown.value.focus();
    }
    filteringFacetsStore[GET_ALL_SELECTED_CRITERIA]();
  } else {
    filteringFacetsStore[REPLACE_SELECTED_VALUES]({
      name: props.name,
      selectedValues: selected,
    });
    filteringFacetsStore[GET_ALL_SELECTED_CRITERIA]();
  }
};
</script>
